import { render } from "./TheUserRecharges.vue?vue&type=template&id=34f501e9"
import script from "./TheUserRecharges.vue?vue&type=script&lang=js"
export * from "./TheUserRecharges.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__